
const button = {
  text: {
    submit: 'Einreichen',
    cancel: 'Stornieren',
    clearFilter: 'Filter löschen',
    close: 'Schließen',
    create: 'Erstellen',
    edit: 'Bearbeiten',
    save: 'Speichern',
  },
};

export default button;
